<template>
  <widgetModal
    :title="questionnaire.title"
    :subtitle="
      questionnaire.user
        ? 'Created by ' +
          questionnaire.user.first_name +
          ' ' +
          questionnaire.user.last_name
        : ''
    "
    btnlefttext=""
    btncentertext="Close"
    btnrighttext=""
    :leftloading="false"
    :rightloading="false"
    :centerloading="false"
    :footerhidden="false"
    footer_padding="20px 20px"
    header_padding="20px 20px 5px 20px"
    body_padding="0px 20px"
    width="580px"
    @onCenterClick="onCancel"
  >
    <div class="widget-modal-body-noscoll">
      <div class="questionnaire-description">
        {{ questionnaire.description }}
      </div>
      <Questionaire :value="questionnaire.question"></Questionaire>
    </div>
  </widgetModal>
</template>

<script>
import Questionaire from "@/views/Instructor/components/widgets/showQuestionaire.vue";

export default {
  name: "",
  components: {
    Questionaire,
  },
  props: {
    questionnaire: {
      type: Object,
      default: null,
    },
  },
  data: () => {
    return {};
  },
  mounted() {},
  computed: {},
  watch: {},
  methods: {
    onCancel() {
      let vm = this;
      vm.$emit("close");
    },
  },
};
</script>
<style lang="scss" scoped>
$assets: "~@/assets";
.questionnaire-description {
  margin-bottom: 20px;
}
</style>


